(function () {
  // Loaded once per knife-lineup-row instance; the first run mounts every instance,
  // and SectionSwipers re-mounts a section when the theme editor adds or re-renders it
  if (window.knifeLineupRowSwiper) return;
  window.knifeLineupRowSwiper = true;

  SectionSwipers.mountEach('.knife-lineup__swiper', function (root) {
    if (typeof Swiper === 'undefined') return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return Array.from(root.querySelectorAll('.knife-lineup__swiper')).map(function (el) {
      return new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 4,
        speed: 6000,
        allowTouchMove: true,
        autoplay: reduceMotion ? false : {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        breakpoints: {
          768: { spaceBetween: 32 }
        }
      });
    });
  });
})();
